function Analytics() {
  this.reachGoal = function reachGoal(yandex, google, vkontakte, facebook) {
    let params = {};

    if (typeof yandex === 'object') {
      params = Object.assign(yandex, {});
    } else {
      params = {
        ya: yandex,
        ga: google,
        vk: vkontakte,
        fb: facebook,
      };
    }

    if (params.ya) {
      try {
        if (window.ym) {
          window.ym(20431690, 'reachGoal', params.ya);
        }
      } catch (e) {
        console.log('yaCounter exception');
        console.log(e.toString());
      }
    }

    if (params.ga) {
      if (typeof params.ga !== 'object') {
        params.ga = {
          name: params.ga,
          action: 'click',
        };
      }
      try {
        if (window.ga) {
          window.ga('send', 'event', params.ga.name, params.ga.action);
        }
        if (window.gtag) {
          window.gtag('event', params.ga.action, { event_category: params.ga.name });
        }
      } catch (e) {
        console.log('GA exception');
        console.log(e.toString());
      }
    }

    if (params.vk) {
      try {
        if (window.VK) {
          window.VK.Retargeting.Event(params.vk);
        }
      } catch (e) {
        console.log('VK.Retargeting.Event exception');
        console.log(e.toString());
      }
    }

    if (params.fb) {
      try {
        if (window.fbq) {
          window.fbq('trackCustom', params.fb);
        }
      } catch (e) {
        console.log('fbq trackCustom exception');
        console.log(e.toString());
      }
    }
  };

  /** функция-обертка, чтобы не копировать аргументы reachGoal четыре раза */
  this.reachGoalAll = function reachGoalAll(eventName) {
    this.reachGoal(eventName, eventName, eventName, eventName);
  };
}

export default new Analytics();
